var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpecialties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.058,
    height: 11.412,
    viewBox: "0 0 11.058 11.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#303030;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M475.4,428.989a.571.571,0,1,1,.554-.571.563.563,0,0,1-.554.571m0-2.283a1.62,1.62,0,0,0-1.551,1.2,2.3,2.3,0,0,0-1.773,2.225v.285a.831.831,0,1,1-1.662,0v-2.054a3.423,3.423,0,0,0,2.77-2.568l.5-1.94a2.605,2.605,0,0,0-.5-2,2.416,2.416,0,0,0-1.773-.856.571.571,0,0,0,0,1.141,1.171,1.171,0,0,1,.942.456,1.389,1.389,0,0,1,.277,1.027l-.5,1.883a2.343,2.343,0,0,1-4.543,0l-.5-1.883a1.389,1.389,0,0,1,.277-1.027,1.254,1.254,0,0,1,.942-.456.571.571,0,0,0,0-1.141,2.416,2.416,0,0,0-1.773.856,2.624,2.624,0,0,0-.5,2.054l.5,1.883a3.423,3.423,0,0,0,2.77,2.568v2.054a1.94,1.94,0,1,0,3.878,0v-.285a1.128,1.128,0,0,1,.665-1.027,1.671,1.671,0,0,0,3.213-.685,1.692,1.692,0,0,0-1.662-1.712",
    transform: "translate(-466 -421)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialties);
export default __webpack_public_path__ + "static/media/specialties.69556107.svg";
export { ForwardRef as ReactComponent };